module.exports = __webpack_public_path__ + "img/d01.d962bcdb.png";